import { createContext, useContext } from "react"

import type { RoomSocketStatus } from "./ws-client"

export interface ConnectionState {
  status: RoomSocketStatus
  canAct: boolean
  actionState: "enabled" | "disabled"
  isOnline: boolean
}

const ConnectionContext = createContext<ConnectionState>({
  status: "idle",
  canAct: false,
  actionState: "disabled",
  isOnline: true,
})

export const ConnectionProvider = ConnectionContext.Provider

export function useConnection() {
  return useContext(ConnectionContext)
}

export function useConnectionState() {
  return useContext(ConnectionContext).actionState
}
